function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint-disable react/display-name */
import React from '../../../_snowpack/pkg/react.js';
import * as Dialog from '../../../_snowpack/pkg/@crystallize/react-dialog.js';
import { DialogButton } from '../../css/index.js';
export default (async (message, callback) => {
  const answer = await Dialog.showConfirm({
    body: message,
    buttons: {
      ok: p => /*#__PURE__*/React.createElement(DialogButton, _extends({
        secondary: true
      }, p), "Leave"),
      cancel: p => /*#__PURE__*/React.createElement(DialogButton, p, "Stay")
    }
  });
  callback(answer === 'ok');
});